//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import goBack from '@/components/public-components/goBack/index.vue'
import mapList from '@/components/public-components/mapList/index.vue'
import EsQuery from '@/javascript/esQuery'
import util from '@/javascript/util'
import Footer from "@/components/lyx-components/lyx-footer/index"

export default {
    name: 'culture',
    components: {
        goBack,
        mapList,
        Footer
    },
    watch: {
        '$route': function (to, from) {
            document.title = '文博专题'
        }
    },
    data() {
        return {
            showMapList: false,
            minHeight: 0,
            mapNav: { title: "123" },
            pageNo: 0,
            pageSize: 7,
            list: [],
            infiniteAll: false,
            infiniteStatus: false,
        }    
    },
    mounted() {
        this.minHeight = document.documentElement.clientHeight
        document.title = '文博专题'
        this.apiList().then(data => {
            this.list = [...this.list, ...data]
            this.pageNo++
        })

        window.addEventListener("scroll", this.windowScroll)
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.windowScroll)
    },
    methods: {
        windowScroll() {
            if (util.pullUpLoad()) {
                this.infinite()
            }
        },
        infinite() {
            if (this.infiniteAll) {
                return
            }
            if (this.infiniteStatus) {
                return
            }
            if (this.list.length == 0) {
                return
            }
            this.infiniteStatus = true
            this.apiList().then(data => {
                this.list = [...this.list, ...data]
                this.pageNo++
            })
        },
        apiList() {
            return new Promise((resolve, reject) => {
                const newsEsQuery = new EsQuery()
                const querystring = require('querystring')
                const catalogCode = "00000000,1720581572781"
                newsEsQuery
                    .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
                    // .addString("category", this.XXCJ_TYPE_CODE.CGLX, newsEsQuery.and, false)
                    .addString("publishStatus", 1, newsEsQuery.asc, false)
                    .addSort("weight", newsEsQuery.desc, false)
                    .addPage(this.pageNo * this.pageSize, this.pageSize)
                const newsJsList = JSON.stringify(newsEsQuery.getArray())
                this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
                    'indexName': this.INDEX_NAME_TYPE.venue,
                    'esJsonQuery': newsJsList
                })).then(res => {
                    this.infiniteAll = res.data.data.length === 0
                    this.infiniteStatus = false
                    resolve(res.data.data)
                })
            })
        },
        goPage(path) {
            location.href = '#' + path
        }
    }
}
